function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import * as React from 'react';
import { TypographyElement } from './Typography.style';

var Typography = function Typography(_ref) {
  var variant = _ref.variant,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["variant", "children"]);

  return /*#__PURE__*/React.createElement(TypographyElement, _extends({
    variant: variant != null ? variant : undefined
  }, props), children);
};

export { Typography };